import { SapAssets } from "@/features"

const SapAssetsPage = () => {
  return <SapAssets />
}

export default SapAssetsPage
